/**
 * Whether the HSK 1 video series card shows on /stories.
 *
 * It is made for learners who said they have never learned Chinese, so by default only they see
 * it, and only until they dismiss it. A link with ?series=hsk1 (the Sunday reader emails send
 * beginners there) shows it to the learner who opened it whatever they reported at sign-up and
 * even if they dismissed it before. They asked for it by following the link, so a closed card
 * would look like a broken email. Closing it on that visit still closes it.
 */
export const SERIES_LINK_VALUE = 'hsk1'

export function seriesRequestedByLink(search: string): boolean {
  return new URLSearchParams(search).get('series') === SERIES_LINK_VALUE
}

export function shouldShowSeries(params: {
  eligible: boolean
  dismissed: boolean
  hiddenThisVisit: boolean
  requestedByLink: boolean
}): boolean {
  if (params.hiddenThisVisit) return false
  if (params.requestedByLink) return true
  return params.eligible && !params.dismissed
}
